import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './switch.module.scss';

const cx = classNames.bind(styles);

const Switch = ({ isChecked, isDisabled, ...otherProps }) => (
  <label className={cx('wrapper', { disabled: isDisabled })}>
    <input type="checkbox" checked={isChecked} disabled={isDisabled} {...otherProps} />
    <span />
  </label>
);

Switch.defaultProps = {
  isDisabled: false,
};

Switch.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};

export default Switch;
